export default "__VITE_ASSET__W1pqklY6__"